// extracted by mini-css-extract-plugin
export default {"containerFaq":"FAQ_containerFaq__+fes3","textContainerFaq":"FAQ_textContainerFaq__zW+fx","document":"FAQ_document__Mii9d"};